import { useState, useEffect } from 'react';

const navItems = [
  { label: '特徴', href: '#features' },
  { label: 'サービス', href: '#services' },
  { label: 'スタッフ', href: '#staff' },
  { label: 'アクセス', href: '#access' },
  { label: 'お問い合わせ', href: '#contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = (href: string) => {
    setMenuOpen(false);
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <>
      <header
        className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
          scrolled ? 'bg-white/95 backdrop-blur-sm border-b border-gray-100' : 'bg-transparent'
        }`}
      >
        <div className="max-w-7xl mx-auto px-6 md:px-10 flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <a
            href="#"
            onClick={(e) => { e.preventDefault(); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
            className="flex items-center gap-2 cursor-pointer"
          >
            <div className="w-8 h-8 flex items-center justify-center">
              <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-8 h-8">
                <circle cx="16" cy="16" r="15" fill="#88B277" fillOpacity="0.15" stroke="#88B277" strokeWidth="1.5" />
                <path d="M16 8C13.5 8 11 10 11 13C11 16 13 17.5 16 20C19 17.5 21 16 21 13C21 10 18.5 8 16 8Z" fill="#88B277" />
                <path d="M10 22C10 22 12 20 16 20C20 20 22 22 22 22" stroke="#88B277" strokeWidth="1.5" strokeLinecap="round" />
              </svg>
            </div>
            <span className={`font-bold text-lg tracking-wide transition-colors duration-300 ${scrolled ? 'text-gray-800' : 'text-white'}`}>
              さくらデイサービス
            </span>
          </a>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className={`text-sm font-medium transition-colors duration-300 hover:text-[#88B277] cursor-pointer whitespace-nowrap ${
                  scrolled ? 'text-gray-600' : 'text-white/90'
                }`}
              >
                {item.label}
              </a>
            ))}
            <a
              href="tel:0120-000-000"
              className="ml-2 px-5 py-2.5 bg-[#88B277] text-white text-sm font-semibold rounded-full hover:bg-[#76a065] transition-colors duration-300 whitespace-nowrap cursor-pointer"
            >
              電話で相談する
            </a>
          </nav>

          {/* Hamburger */}
          <button
            className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
            onClick={() => setMenuOpen(!menuOpen)}
            aria-label="メニューを開く"
          >
            {menuOpen ? (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#374151" strokeWidth="2" strokeLinecap="round">
                <line x1="18" y1="6" x2="6" y2="18" />
                <line x1="6" y1="6" x2="18" y2="18" />
              </svg>
            ) : (
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={scrolled ? '#374151' : 'white'} strokeWidth="2" strokeLinecap="round">
                <line x1="3" y1="6" x2="21" y2="6" />
                <line x1="3" y1="12" x2="21" y2="12" />
                <line x1="3" y1="18" x2="21" y2="18" />
              </svg>
            )}
          </button>
        </div>
      </header>

      {/* Mobile Menu Panel */}
      <div
        className={`fixed inset-0 z-40 md:hidden transition-all duration-300 ${
          menuOpen ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
      >
        <div className="absolute inset-0 bg-black/40" onClick={() => setMenuOpen(false)} />
        <div
          className={`absolute top-0 right-0 h-full w-72 bg-white rounded-l-3xl shadow-xl transition-transform duration-400 ${
            menuOpen ? 'translate-x-0' : 'translate-x-full'
          }`}
        >
          <div className="pt-24 px-8 flex flex-col gap-2">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => { e.preventDefault(); handleNavClick(item.href); }}
                className="py-4 text-gray-700 font-medium text-base border-b border-gray-100 hover:text-[#88B277] transition-colors cursor-pointer whitespace-nowrap"
              >
                {item.label}
              </a>
            ))}
            <a
              href="tel:0120-000-000"
              className="mt-6 py-3.5 bg-[#88B277] text-white text-center font-semibold rounded-2xl hover:bg-[#76a065] transition-colors cursor-pointer whitespace-nowrap"
            >
              電話で相談する
            </a>
          </div>
        </div>
      </div>
    </>
  );
}
